import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Vessel } from 'icreate/common/models/vessel';

@Component({
    selector: 'app-access-removed-dialog',
    templateUrl: './access-removed-dialog.component.html',
    styleUrl: './access-removed-dialog.component.css',
    standalone: false,
})
export class AccessRemovedDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<AccessRemovedDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            vessel: Vessel;
        }
    ) {}

    cancel() {
        this.dialogRef.close(false);
    }
}
